import { Component, Input } from '@angular/core';

import { Catalog } from '../shared/catalog.interface';

@Component({
  selector: 'igo-catalog-item',
  template: require('./catalog-item.component.html'),
  styles: [require('./catalog-item.component.styl')]
})
export class CatalogItemComponent {
  public color: string = 'primary';

  @Input()
  get catalog(): Catalog { return this._catalog; }
  set catalog(value: Catalog) {
    this._catalog = value;
  }
  private _catalog: Catalog;

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/catalog-item/catalog-item.component.ts